import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({standalone: true, name: 'template'})
export class TemplateReplacePipe implements PipeTransform {
  constructor(private sanitizer?: DomSanitizer) {}
  transform(message: string, mapping: { [key: string]: any }): SafeHtml {
    if (!message || !mapping) {
      return message;
    }

    for (const key in mapping) {
      if (mapping.hasOwnProperty(key)) {
        const paramValue = typeof mapping[key] === 'function' ? mapping[key]() : mapping[key];
        message = message.replace(new RegExp(`{{${key}}}`, 'g'), paramValue);
      }
    }

    if (message.includes('<') && message.includes('>')) {
      return this.sanitizer.bypassSecurityTrustHtml(message);
    } else {
      return message;
    }
  }
}
